import React, {useState} from 'react';
import AgyleDialog from '../../modal/agyleDialog';
import {FormLabel} from '@mui/material';
import AgyleTextField from '../../ui/fields/agyleTextField';
import _ from 'lodash';
import API from '../../../app/api';
import {loadNotesForPatient, removeNotes} from '../../../store/reducers/notes';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {setSnackbar} from '../../../store/reducers/globals';

const MarkAsErrorNote = ({open, onClose, patient, note}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const [reason, setReason] = useState('');

    const cancelNote = () => {
        if (reason !== '' && !_.isNil(note)) {
            API.cancelNoteWithReason(patient.patient.__id, note?.__id, reason)
                .then(res => {
                    if (res) {
                        dispatch(removeNotes());
                        handleDialogClose();
                        reloadNotes();
                        dispatch(setSnackbar({
                            type: 'success',
                            message: 'The note has been marked as an error.',
                        }));
                    }
                })
                .catch(e => {
                    console.error(e);
                    dispatch(setSnackbar({
                        type: 'error',
                        message: 'An error occurred when marking a note as error.',
                    }));
                });
        }
    };

    const reloadNotes = () => {
        dispatch(loadNotesForPatient(patient));
    };

    const handleDialogClose = () => {
        setReason('');
        onClose();
    };

    const handleChangeReason = (event) => {
        setReason(event.target.value);
    };

    return (
        <AgyleDialog
            open={open}
            title={t('Marks Note as Error')}
            width="md"
            fullWidth
            onClose={handleDialogClose}
            disableSubmit={reason === ''}
            onSave={cancelNote}
        >
            <>
                <FormLabel>
                    {t('Provide reason for this action')}
                </FormLabel>

                <AgyleTextField
                    multiline
                    value={reason}
                    style={{marginTop: 10}}
                    onChange={handleChangeReason}
                    fullWidth
                />
            </>
        </AgyleDialog>
    );
};

export default MarkAsErrorNote;